<template>
  <el-form ref="form" label-width="120px">
    <span>加入设置</span>
    <el-button size="mini" type="primary" class="right" @click="edit(course.code_id,course.type)">编辑</el-button>
    <el-divider></el-divider>
  </el-form>
</template>

<script>
import { url } from "@/utils/config"
export default {
  props: ['course'],
  data() {
    return {
    };
  },
  methods: {
    edit(id, type) {
      if (type == 1) {
        var path = '/study-path/index?master='
      } else if (type == 2) {
        var path = '/examine/index?test='
      }
      window.open(url + path + id, "_blank");
      // window.open('http://create.skillbox.cn/study-path/index?master='+id, "_blank");
    },
  }
};
</script>

<style scoped>
.warning {
  color: #ff8a0c;
}
</style>
